import Vue from 'vue'
import Vuex from 'vuex'
import suggestedItemsService from '../api/suggestedItems'

Vue.use(Vuex)

const initialState = {
  suggestions: [],
  selectedSuggestion: null
}

const getters = {
  suggestions(state) {
    return state.suggestions
  },
  selectedSuggestion(state) {
    return state.selectedSuggestion
  }
}

const mutations = {
  setSuggestions(state, payload) {
    state.suggestions = payload
  },
  setSelectedSuggestion(state, payload) {
    state.selectedSuggestion = payload
  }
}

export const actions = {
  async acceptSuggestedImages(context, payload) {
    try {
      const response = await suggestedItemsService.acceptSuggestedImages(payload);
      return Promise.resolve();
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async deleteSuggestedImages(context, payload) {
    try {
      const response = await suggestedItemsService.deleteSuggestedImages(payload);
      return Promise.resolve();
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async getSuggestedImages(context, payload) {
    try {
      const response = await suggestedItemsService.getSuggestedImages(payload);
      context.state.suggestions = response.data
      return Promise.resolve();
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async getSuggestedImageByUser(context, payload) {
    try {
      const response = await suggestedItemsService.getSuggestedImageByUser(payload);
      context.state.selectedSuggestion = response.data;
      return Promise.resolve();
    } catch (error) {
      context.commit('toast', { message: context.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  }
}

export const state = { ...initialState }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
